import { Event } from './event';

export class ClearEnrolmentSelectionRequestedEvent extends Event<void> {}
